import { FC } from 'react'

import styled from 'styled-components'
import { Tooltip } from '@mantine/core'

import { Button, PrimaryButtonProps } from 'src/Components/Button/index.tsx'
import { colors } from 'src/Helpers/constants'

const StyledAddButton = styled(Button)`
  padding: 0;
  width: 35px;
  height: 35px;
  background: none;

  &:hover {
    background-color: unset;
    border: none;
  }
  &:disabled {
    color: white;
    background-color: ${colors.thirdGray} !important;
    &:hover {
      background-color: ${colors.thirdGray} !important;
    }
  }
`

export interface IconButtonProps extends PrimaryButtonProps {
  tooltiptext?: string
}

export const IconButton: FC<IconButtonProps> = ({ tooltiptext, ...props }) => {
  const button = <StyledAddButton {...props}>{props.children}</StyledAddButton>

  if (tooltiptext) {
    return <Tooltip label={tooltiptext}>{button}</Tooltip>
  }

  return button
}
